export const getStatusColor = (
  status: string
): "purple" | "green" | "yellow" | "red" | "gray" | "blue" => {
  switch (status) {
    case "AWAITING_ANALYSIS":
      return "yellow";
    case "AWAITING_REANALYSIS":
      return "yellow";
    case "IN_PROGRESS":
      return "blue";
    case "RESOLVED":
      return "green";
    case "FILED":
      return "gray";
    case "RETURNED":
      return "red";
    case "REJECTED":
      return "red";
    case "CANCELLED":
      return "gray";
    case "REOPENED":
      return "blue";
    default:
      return "gray";
  }
};
